import React, {useState} from 'react';
import questionareStyle from '../../style';

export default function Slide8(props) {
	let style = questionareStyle();
	let [goals, setGoals] = useState(null);

	return (
		<div style={style.ageInputContainer()}>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				List your short and long term goals
			</p>
			<textarea
				className={'mt-3'}
				placeholder={'- lose weight\n- build muscle)'}
				type='email'
				onChange={updatedGoals}
			/>
			<button
				style={style.nextButton()}
				onClick={() => {
					props.nextPressed({listOfGoals: goals}, {createUser: true});
				}}
			>
				Next
			</button>
		</div>
	);

	function updatedGoals(e) {
		let value = e.target.value;
		setGoals(value);
	}
}
